import type { Home } from '@lmc/ts-common'
import {
  FormItem,
  FormRadio,
  FormRadioGroup,
  GroupedResidentsMultiSelect,
  RangePicker
} from '@lmc/ui-kit'
import { type FormInstance, Select } from 'antd'
import useResidentsList from 'hooks/useResidentsList'
import { NAMESPACE } from 'locale'
import { reportingTranslations } from 'locale/reporting'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type Props = {
  preferredPeopleNominative: string
  preferredCarePlansNominative: string
  isGroupDownload?: boolean
  form?: FormInstance<any>
}

export const CarePlanExportForm: FC<Props> = ({
  preferredPeopleNominative,
  preferredCarePlansNominative,
  isGroupDownload,
  form
}) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  const { residents } = useResidentsList({})

  const homes = useSelector(
    (state: { data: { homes: Home[] } }) => state.data.homes
  )

  const homeOptions = homes?.map((home) => ({
    value: home?.id,
    label: home?.name
  }))

  return (
    <>
      <StyledFormItem
        label={t(reportingTranslations.CARE_PLANS_CREATED, {
          variable: preferredCarePlansNominative
        })}
        name="dateRange"
        extra={t(reportingTranslations.SELECTED_DATES)}
      >
        <RangePicker />
      </StyledFormItem>
      <FormItem
        label={preferredPeopleNominative}
        name="residents"
        extra={t(reportingTranslations.SELECT_ENTITY, {
          variable: preferredPeopleNominative
        })}
      >
        <GroupedResidentsMultiSelect
          residents={residents}
          title={preferredPeopleNominative || ''}
          handleInputChange={(values) =>
            form?.setFieldValue('residents', values)
          }
          placeholder={false}
        />
      </FormItem>
      <FormItem
        label={t(reportingTranslations.CARE_PLANS_STATUS)}
        name="showCurrentOnly"
        extra={t(reportingTranslations.SELECT_TO_INCLUDE_CARE_PLANS, {
          variable: preferredCarePlansNominative
        })}
      >
        <FormRadioGroup>
          <FormRadio value text={t(reportingTranslations.CURRENT_ONLY)} />
          <FormRadio
            value={false}
            text={t(reportingTranslations.CURRENT_AND_HISTORIC_RECORDS)}
          />
        </FormRadioGroup>
      </FormItem>
      {isGroupDownload && (
        <FormItem
          label={t(reportingTranslations.SITES)}
          name="sites"
          extra={t(reportingTranslations.SITES_EXTRA)}
          rules={[
            {
              required: true
            }
          ]}
        >
          <Select options={homeOptions} mode="multiple" />
        </FormItem>
      )}
    </>
  )
}

const StyledFormItem = styled(FormItem)`
  .ant-form-item-label {
    white-space: nowrap !important;
  }
`
